<template>
  <div class="">
    <h1>Line 通知綁定結果頁面</h1>
  </div>
</template>

<script>
import { LINE_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'LineAuth',

  data() {
    const code = this.$route.query.code

    return {
      code,

      sending: false
    }
  },
  mounted() {
    this.auth(this.$route.query.code)
  },
  methods: {
    async auth(code) {
      const api = `${LINE_API}/auth`

      try {
        this.sending = true
        const res = await this.axios.post(api, { code })
        const result = res.data
        const data = result.data

        // eslint-disable-next-line no-console
        console.log(result)

        if (result.success) {
          notifyService.success(data.message)
        } else {
          notifyService.error(data.message)
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        notifyService.error(e.message)
      } finally {
        this.isSending = false
      }
    }
  }
}
</script>
